import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { FormBlockTypes } from './DocumentPreviewSubjectData';

type DocumentPreviewBock7Props = {
  data: FormBlockTypes;
};

export const DocumentPreviewBlock7 = ({ data }: DocumentPreviewBock7Props) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      key: 'block7Data',
      block7Data: {},
    };
    if (data.comments) {
      changedTableData.block7Data = data.comments;
    }
    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>Pastabos, komentarai</Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'block7Data',
            title: 'Pastabos, komentarai',
            dataIndex: 'block7Data',
          },
        ]}
        dataSource={[tableData]}
        size="small"
      />
    </div>
  );
};
